export default __webpack_public_path__ + "dist/media/Billing.4506b47e.svg";